import React from "react";
import { InfoIndicator } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/components/InfoIndicator";
import { AutomationVariableListItem } from "../../types";
import { VariableListItem } from "../VariableListItem";

type VariableListSectionProps = {
  title: string;
  tooltip?: string;
  items: AutomationVariableListItem[];
  getDescription: (item: AutomationVariableListItem) => string | undefined;
  onItemClick: (id: string) => void;
};

export const VariableListSection: React.FC<VariableListSectionProps> = ({
  title,
  items,
  tooltip,
  getDescription,
  onItemClick,
}) => (
  <div className="flex flex-col gap-1.5">
    <div className="flex h-8 items-center justify-between px-2">
      <span className="font-secondary text-xs font-medium text-dark-800">
        {title}
      </span>
      {tooltip && <InfoIndicator message={tooltip} tooltipPlacement="top" />}
    </div>
    <div className="flex flex-col gap-1.5">
      {items.map((item) => (
        <VariableListItem
          key={item.id}
          item={item}
          description={getDescription(item)}
          onClick={onItemClick}
        />
      ))}
    </div>
  </div>
);
